import customAxios from "./axiosConfig";

const CompanyService = {
  list: function () {
    return customAxios.get(window.Urls["company_profile_list"]());
  },
  getBusinessEntities: function () {
    return customAxios.get(window.Urls["company_profile_business_entities_choices"]());
  },
  getSectors: function () {
    return customAxios.get(window.Urls["company_profile_sector_choices"]());
  },
  getCountries: function () {
    return customAxios.get(window.Urls["company_profile_country_choices"]());
  },
  getAllChoices: function() {
    return customAxios.get(window.Urls["company_profile_all_choices"]());
  },
  getCurrent: function () {
    const api_url = window.Urls["company_profile_detail"](window.company_id)
    return customAxios.get(api_url, { params: { extended: true } });
  },
  update: function (data) {
    const config = {
        headers: { 'content-type': 'application/json;charset=UTF-8' },
    };
    return customAxios.put(window.Urls["company_profile_detail"](data.id), data, config);
  },
  companyPickerOptions: function(){
    return customAxios.get(window.Urls["company_profile_company_picker_options"]());
  },
  getAccessRights: function () {
    return customAxios.get(window.Urls["company_profile_access_rights"](window.company_id));
  },
  getNextCostNumber: function(data){
    var api_url = window.Urls['company-profile-next-cost-number'](window.company_id);
    return customAxios.post(api_url, data);
  },
  financiallyActiveYears: function() {
    var api_url = window.Urls['companyProfileFinanciallyActiveYears'](window.company_id);
    return customAxios.get(api_url);
  },
  retrieveAccountant (accountant_id) {
    const api_url = '/api/v2/accountant-profiles/' + accountant_id + '/'
    return customAxios.get(api_url);
  },
  retrieveAccountantConnections (company_id) {
    const api_url = '/api/v2/accountant-connections/'
    return customAxios.get(api_url, { params: { company_id: company_id } });
  },
  downloadData(company_id,data){
    const api_url = window.Urls["company_profile_download_data"](company_id);
    return customAxios.post(api_url, data);
  },
  searchKvk(params) {
    var api_url = window.Urls['company-profile-search-kvk']();
    return customAxios.get(api_url, {params: params});
  },
  importKvk(data) {
    var api_url = window.Urls['company-profile-kvk-import'](window.company_id);
    return customAxios.post(api_url, data);
  },
  getKvkPageByUrl(params) {
    var api_url = window.Urls['company-profile-get-kvk-page-by-link']();
    return customAxios.get(api_url, {params: params});
  },
  kvkDataToCompany(kvkData) {
    let companyData = {}

    companyData.name = kvkData.handelsnaam;
    companyData.city = kvkData.plaats;
    companyData.address = kvkData.straatnaam;
    companyData.btw = kvkData.vestigingsnummer;
    companyData.kvk = kvkData.kvkNummer;
    companyData.country = "NL";

    return CompanyService.getAllChoices().then((choices) => {
      let kvk_legal_form_options = choices.data.kvk_legal_form_options;

      let params = {url: kvkData.links[0].href};
      return CompanyService.getKvkPageByUrl(params).then((response) => {
          if ('hoofdvestiging' in response.data['_embedded'] && 'adressen' in response.data['_embedded']['hoofdvestiging']) {
              let address = response.data['_embedded']['hoofdvestiging']['adressen'][0];

              let street_address = '';
              if (address['straatnaam'])
                  street_address = address['straatnaam'];
              if (address['huisnummer'])
                  street_address = street_address + ' ' + address['huisnummer'];
              if (address['huisnummertoevoeging'])
                  street_address = street_address + '-' + address['huisnummertoevoeging'];

              companyData.address = street_address;
              companyData.postal_code = address['postcode'];
              companyData.city = address['plaats'];
          }

          let business_activities = response.data['sbiActiviteiten'][0];
          companyData.description = business_activities['sbiOmschrijving'];
          companyData.sbi_description = business_activities['sbiOmschrijving'];
          companyData.sbi_code = business_activities['sbiCode'];
          
          if (response.data['_embedded']['hoofdvestiging']['websites'])
              companyData.website = response.data['_embedded']['hoofdvestiging']['websites'][0];
          
          if (kvk_legal_form_options) {
              if (response.data['_embedded']['eigenaar']['rechtsvorm'] in kvk_legal_form_options)
                  companyData.legal_form = kvk_legal_form_options[response.data['_embedded']['eigenaar']['rechtsvorm']];
          }

          return companyData;
      });
    });
  }
};

export default CompanyService;